<!--
 * @Author: chenshouliang m17635645973@163.com
 * @Date: 2026-04-09 15:49:56
 * @LastEditors: chenshouliang m17635645973@163.com
 * @LastEditTime: 2026-04-13 10:33:43
 * @FilePath: /ganxibao_screen/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="root-BG" id="root-ui">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style lang="less" scoped>
@import "./style.less";
</style>
